import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core'
import { CondOperator, RequestQueryBuilder } from '@nestjsx/crud-request'
import { Dictionary } from '@ngrx/entity'
import { Store } from '@ngrx/store'
import moment from 'moment-mini'
import { BsModalService } from 'ngx-bootstrap/modal'
import { Observable, of } from 'rxjs'
import {
  bufferCount,
  catchError,
  map,
  take,
  timeout,
  withLatestFrom
} from 'rxjs/operators'
import { authSelectors } from 'src/app/core/auth/auth.selectors'
import { AppState } from 'src/app/core/core.state'
import { Booking } from 'src/app/features/booking/booking'
import { bookingSelectors } from 'src/app/features/booking/booking.selectors'
import { Member } from 'src/app/features/member/member'
import { Product } from 'src/app/features/product/product'
import { productSelectors } from 'src/app/features/product/product.selectors'
import { SupervisorBookingDetailsModalComponent } from '../details-modal/show.component'
import {
  SupervisorBooking,
  SupervisorBookingStatus
} from '../supervisor-booking'
import { supervisorBookingActions } from '../supervisor-booking.actions'
import { supervisorBookingSelectors } from '../supervisor-booking.selectors'
import { environment } from 'src/environments/environment'
import { Actions, ofType } from '@ngrx/effects'
import { NotificationService } from 'src/app/core/notification.service'

@Component({
  selector: 'supervisor-booking-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class SupervisorBookingIndex implements OnInit, AfterViewInit {
  public supervisorBookings$: Observable<SupervisorBooking[]>
  public member$: Observable<Member>
  public bookingEntities$: Observable<Dictionary<Booking>>
  public productEntities$: Observable<Dictionary<Product>>
  public isLoading$: Observable<boolean>
  public supervisorModuleConfig = environment.moduleConfigs.supervisorModule
  public selectedState: 'accept' | 'none' | 'decline' = 'none'
  public checkedItemsIds: Map<number, string> = new Map()
  public showBulkButton = false
  @ViewChildren('toggleSwitch') toggleSwitches:
    | QueryList<ElementRef>
    | undefined

  constructor(
    private actions$: Actions,
    private notificationService: NotificationService,
    private store: Store<AppState>,
    private modalService: BsModalService
  ) {}

  ngOnInit() {
    this.isLoading$ = this.store.select(
      supervisorBookingSelectors.selectIsLoading
    )
    this.member$ = this.store.select(authSelectors.selectMember)
    this.bookingEntities$ = this.store.select(bookingSelectors.selectEntities)
    this.productEntities$ = this.store.select(productSelectors.selectEntities)

    this.member$.pipe(take(1)).subscribe((member) =>
      this.store.dispatch(
        supervisorBookingActions.fetchMany({
          params: RequestQueryBuilder.create({
            search: {
              status: {
                [CondOperator.IN]: [
                  SupervisorBookingStatus.INVITED,
                  SupervisorBookingStatus.REMINDED
                ]
              },
              personId: member.id
            },
            join: [
              { field: 'booking' },
              { field: 'booking.linkedProduct' },
              { field: 'booking.product' },
              { field: 'booking.linkedProduct.translations' },
              { field: 'booking.product.translations' }
            ]
          })
        })
      )
    )

    this.supervisorBookings$ = this.store
      .select(supervisorBookingSelectors.selectAll)
      .pipe(
        withLatestFrom(this.store.select(bookingSelectors.selectEntities)),
        map(([supervisorBookings, bookingEntities]) => {
          return supervisorBookings.filter(
            (supervisorBooking) =>
              (supervisorBooking.status == SupervisorBookingStatus.INVITED ||
                supervisorBooking.status == SupervisorBookingStatus.REMINDED) &&
              moment(
                bookingEntities[supervisorBooking.bookingId]?.endDate
              ).valueOf() > moment().valueOf()
          )
        })
      )
  }
  ngAfterViewInit() {
    if (this.toggleSwitches && this.toggleSwitches.length > 0) {
      this.showBulkButton = true
    }
  }
  public setState(id: number, state: 'accept' | 'decline') {
    if (this.checkedItemsIds.has(id) && this.checkedItemsIds.get(id) == state) {
      this.checkedItemsIds.delete(id)
    } else {
      this.checkedItemsIds.set(id, state)
    }
    if (this.toggleSwitches && this.toggleSwitches.length > 0) {
      this.showBulkButton = true
    }
  }
  public onClickApplyActions() {
    if (this.checkedItemsIds.size > 0) {
      this.actions$
        .pipe(
          ofType(supervisorBookingActions.upsertMany),
          bufferCount(this.checkedItemsIds.size),
          catchError((err) => {
            this.checkedItemsIds.clear()
            return of(null)
          })
        )
        .subscribe((action) => {
          this.checkedItemsIds.clear()
          this.notificationService.emit('alerts.success', 'success')
        })
      this.checkedItemsIds.forEach((value, key) => {
        if (value === 'accept') {
          this.store.dispatch(
            supervisorBookingActions.updateOneById({
              id: key,
              params: { status: SupervisorBookingStatus.ACCEPTED }
            })
          )
        } else if (value === 'decline') {
          this.store.dispatch(
            supervisorBookingActions.updateOneById({
              id: key,
              params: { status: SupervisorBookingStatus.DECLINED }
            })
          )
        }
      })
    }
  }
  public onClickDetails(supervisorBooking: SupervisorBooking) {
    this.modalService.show(SupervisorBookingDetailsModalComponent, {
      initialState: {
        bookingId: supervisorBooking.bookingId,
        supervisorBookingId: supervisorBooking.id
      },
      class: 'modal-lg'
    })
  }
}
